const getAllowedAppProductUsers = () => (
  process.env.REACT_APP_allowed_app_product_management
  || process.env.REACT_APP_ALLOWED_APP_PRODUCT_MANAGEMENT
  || ''
).split(',').map((userId) => userId.trim()).filter(Boolean);

export const getCurrentWixUserId = () => {
  try {
    return JSON.parse(sessionStorage.getItem('wixStoreDetails') || '{}')?.wixUserId || '';
  } catch {
    return '';
  }
};

export const isAppProductManagementAllowed = () => {
  const wixUserId = String(getCurrentWixUserId());
  return Boolean(wixUserId) && getAllowedAppProductUsers().includes(wixUserId);
};
